import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class NgSimpleSeoService {

  constructor(
    // Application Services
    private title: Title,
    private meta: Meta
  ) {}

  public set(
    title?,
    keywords?,
    description?,
    twitterTitle?,
    twitterDescription?,
    twitterImage?,
    twitterSite?,
    twitterCreator?,
    ogTitle?,
    ogType?,
    ogDescription?,
    ogImage?,
    ogUrl?,
    ogSitename?
  ): void {
    this.title.setTitle(`${title}`);
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });

    if ( description !== undefined) {
      this.meta.updateTag({ name: 'description', content: description });
    }

    if ( keywords !== undefined) {
      this.meta.updateTag({ name: 'keywords', content: keywords });
    }

    if ( twitterTitle !== undefined) {
      this.meta.updateTag({ name: 'twitter:title', content: twitterTitle });
    }
    if ( twitterDescription !== undefined) {
      this.meta.updateTag({ name: 'twitter:description', content: twitterDescription });
    }
    if ( twitterImage !== undefined) {
      this.meta.updateTag({ name: 'twitter:image', content: twitterImage });
    }
    if ( twitterSite !== undefined) {
      this.meta.updateTag({ name: 'twitter:site', content: twitterSite });
    }
    if ( twitterCreator !== undefined) {
      this.meta.updateTag({ name: 'twitter:creator', content: twitterCreator });
    }
    if ( ogTitle !== undefined) {
      this.meta.updateTag({ name: 'og:title', content: ogTitle });
    }
    if ( ogType !== undefined) {
      this.meta.updateTag({ name: 'og:type', content: ogType });
    }
    if ( ogDescription !== undefined) {
      this.meta.updateTag({ name: 'og:description', content: ogDescription });
    }
    if ( ogImage !== undefined) {
      this.meta.updateTag({ name: 'og:image', content: ogImage });
    }
    if ( ogUrl !== undefined) {
      this.meta.updateTag({ name: 'og:url', content: ogUrl });
    }
    if ( ogSitename !== undefined) {
      this.meta.updateTag({ name: 'og:site_name', content: ogSitename });
    }
  }
}
